import React, { FC, useState } from "react";
import ReactDOM from "react-dom";
import BundleCarouselContainer from "./components/Bundles/BundleCarousel";

if(document.getElementById('bundle-carousel')){
  ReactDOM.render(<BundleCarouselContainer />, document.getElementById('bundle-carousel'));
}